import React, { useState } from "react"
import { trans } from "@/_providers/Translation"
import { Tab, Tabs } from "@mui/material"
import "@/assets/scss/pages/catalogue.scss"

import Catalogue from "./partials/Catalogue"
import Orders from "./partials/Orders"

function Index() {
  const [activeTab, setActiveTab] = useState(1)

  return (
    <>
      <div id="catalogue" className="wrapper">
        <div className="top-part">
          <div className="left">
            <h1 className="page-heading">{trans("catalogue.heading")}</h1>
            <p className="page-subheading">{trans("catalogue.subheading")}</p>
          </div>
        </div>
        <Tabs
          value={activeTab}
          onChange={(e, id) => setActiveTab(id)}
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="primary"
          textColor="primary"
          aria-label="catalogue tabs"
        >
          <Tab value={1} label={trans("catalogue.tabCatalogue")} />
          <Tab value={2} label={trans("catalogue.tabOrders")} />
        </Tabs>

        {activeTab === 1 && <Catalogue />}
        {activeTab === 2 && <Orders />}
      </div>
    </>
  )
}

export default Index
